import { render, staticRenderFns } from "./PlanejamentoAcaoFormAcoesFluxo.vue?vue&type=template&id=121c32b0"
import script from "./PlanejamentoAcaoFormAcoesFluxo.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormAcoesFluxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports